import { isRpcError } from 'pricing-pages-lib/utils/errors';
import Raven from 'raven-js';
export default function makeRequest({
  fetch,
  payload,
  requestActions
}) {
  return dispatch => {
    dispatch(requestActions.request(payload));
    return fetch(payload).then(resp => {
      return dispatch(requestActions.receive(resp, payload));
    }).catch(err => {
      dispatch(requestActions.failure(err, payload));
      if (!isRpcError(err) || err.cause.status !== 0) {
        Raven.captureException(err, {
          extra: {
            payload,
            cause: err.cause
          }
        });
      }
    });
  };
}